/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Check_SkillsInputs */

const en_rd_check_skills = /** @type {(inputs: Rd_Check_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reusable agent skills`)
};

const id_rd_check_skills = /** @type {(inputs: Rd_Check_SkillsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Skill agent yang bisa dipakai ulang`)
};

/**
* | output |
* | --- |
* | "Reusable agent skills" |
*
* @param {Rd_Check_SkillsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_check_skills = /** @type {((inputs?: Rd_Check_SkillsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Check_SkillsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_check_skills(inputs)
	return en_rd_check_skills(inputs)
});